import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import theme from './theme';
import GlobalStyle from './assets/styles/global';
import { AuthProvider } from './contexts/AuthContext';

import Landing from './pages/Landing';
import Connect from './pages/Connect';
import Bias from './pages/Bias';
import Villkor from './pages/Villkor';
import Integritet from './pages/Integritet';
import Cookies from './pages/Cookies';
import TestaFaktura from './pages/TestaFaktura';
import Portfolio from './pages/Portfolio';
import Admin from './pages/Admin';
import OutcomeSurvey from './pages/OutcomeSurvey';
import Briefing from './pages/Briefing';
import Intelligence from './pages/Intelligence';
import Aktivera from './pages/Aktivera';
import Prospect from './pages/Prospect';
import ScrollToTop from './components/ScrollToTop';

const ArvoFlow = () => (
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
      <AuthProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/connect" element={<Connect />} />
          <Route path="/bias" element={<Bias />} />
          <Route path="/villkor" element={<Villkor />} />
          <Route path="/integritet" element={<Integritet />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/testa-faktura" element={<TestaFaktura />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/utfall" element={<OutcomeSurvey />} />
          <Route path="/briefing/:token" element={<Briefing />} />
          <Route path="/intelligence" element={<Intelligence />} />
          <Route path="/aktivera" element={<Aktivera />} />
          <Route path="/prospect/:token" element={<Prospect />} />
          {/* Ett rum. Den statiska Kontoret-prototypen är avroutad; /kontoret → det levande rummet. */}
          <Route path="/kontoret" element={<Navigate to="/portfolio" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </ThemeProvider>
);

export default ArvoFlow;
